import config from '@/config';
import isSSR from '@/utils/isSSR';
import logger from '@/app/logger';
import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';
import type { Ref } from 'vue';

export const getDemographicsQueryKey = (postalCodeRef: Ref<string>) => ['demographics', postalCodeRef];
export const demographicsQuery = async (postalCode: string) => {
  const url = isSSR ? `${config.BACKEND.URL}/demographics/${postalCode}` : `/api/demographics/${postalCode}`;
  logger.info(`Fetching demographics data: ${url}...`);
  return axios
    .get(url)
    .then((res) => {
      logger.info('Demographics: Got response');
      return res.data;
    })
    .catch((err: unknown) => {
      logger.info('Demographics: Got error:', err);
      return Promise.reject(err);
    });
};

export default function useDemographicsData(postalCodeRef: Ref<string>) {
  return useQuery({
    queryKey: getDemographicsQueryKey(postalCodeRef),
    queryFn: () => demographicsQuery(postalCodeRef.value),
    enabled: () => !!postalCodeRef.value,
  });
}
